<template>
  <!-- TOOLBAR START -->
  <div class="user-toolbar">
    <v-card-title class="toolbar primary white--text">
      <div>
        <span class="headline">
          <v-icon dark>fingerprint</v-icon>
          <h1 class="headline ml-2">Ident cases</h1>
        </span>
      </div>
      <v-spacer />
      <!-- SEARCH AUTOCOMPLETE START -->
      <ident-user-search
        :on-user-select="onUserSelect"
        :is-loading-user-detail="isLoadingUserDetail"
        :current-user="currentUser"
        :dark="true"
      />
      <!-- SEARCH AUTOCOMPLETE END -->
    </v-card-title>
  </div>
  <!-- TOOLBAR END -->
</template>

<script>
/**
 * This toolbar component triggers a user search
 * Its controlled through props so that the main ident view triggers the store
 */
import IdentUserSearch from './shared/IdentUserSearch';

export default {
  name: 'IdentToolbar',
  components: { IdentUserSearch },
  props: {
    onUserSelect: {
      type: Function,
      required: true,
    },
    isLoadingUserDetail: {
      type: Boolean,
      required: true,
    },
    currentUser: {
      type: Object,
      default: null,
    },
  },
};
</script>
<style lang="scss">
.user-toolbar {
  .toolbar {
    padding: 24px 76px 34px 24px;
    .v-autocomplete {
      min-width: 60%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ident/IdentToolbar.vue